/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { lazy } from 'react';
import DefaultModal from './DefaultModal';

import Styles from '../../css/modals/PrivacySettingsModal.module.css';
import useLazyComponent from '../../common/hooks/useLazyComponent';
import { CircularProgress } from '@mui/material';

const EditBorrowerNameForm = lazy(() => import('../../components/forms/EditBorrowerNameForm'));

type Props = {
    borrowerNumber?: string;
    open?: string | false | undefined;
    onClose: () => void;
    onAfterSave?: (borrowerNumber: string, values: { firstName: string; middleName: string; lastName: string; suffix: string }) => void;
  };

function EditBorrowerNameModal({ borrowerNumber, open, onClose, onAfterSave }: Props) {
  const formProps = { borrowerNumber, onClose, onAfterSave };
  const EditBorrowerNameFormLazy = useLazyComponent(
    EditBorrowerNameForm,
    <CircularProgress />,
    `EditBorrowerNameForm: ${JSON.stringify({ borrowerNumber })}`,
  );

  return (
    <DefaultModal open={!!open} className={Styles.section}>
      <EditBorrowerNameFormLazy {...formProps} />
    </DefaultModal>
  );
}

export default EditBorrowerNameModal;
